export default __webpack_public_path__ + "aa9710fcdc011ea5cd15d5ed76b208e0.png";